import React from "react";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 section-light overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Left: Text */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <span className="text-xs uppercase tracking-[0.25em] text-[#E52431]">
              — Qui sommes-nous
            </span>

            <h2 className="mt-4 font-outfit text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#0A0A0A] leading-[1.05]">
              Nous ne faisons pas{" "}
              <span className="italic text-[#0A0A0A]/80">que</span> du digital.
              <br />
              Nous créons des outils pour{" "}
              <span className="gradient-text font-medium">
                faire grandir votre business
              </span>
              .
            </h2>

            <div className="mt-10 space-y-5 text-[#0A0A0A]/70 text-lg font-light leading-relaxed max-w-xl">
              <p>
                EM Group est un cabinet de conseil digital spécialisé dans le
                développement et la performance des entreprises.
              </p>
              <p>
                Nous accompagnons nos clients dans la création de leur image,
                le développement de leur présence en ligne et la mise en place
                de stratégies efficaces.
              </p>
              <p className="text-[#0A0A0A]/85 font-normal">
                Notre objectif&nbsp;: faire du digital un véritable levier de
                croissance.
              </p>
            </div>

            {/* KPIs */}
            <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl">
              {[
                { n: "100%", l: "Sur-mesure" },
                { n: "24h", l: "Délai de réponse" },
                { n: "3", l: "Territoires" },
              ].map((k, i) => (
                <motion.div
                  key={k.l}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: 0.15 + i * 0.08 }}
                  className="border-l-2 border-[#E52431] pl-4"
                >
                  <div className="font-outfit text-3xl md:text-4xl font-light text-[#0A0A0A]">
                    {k.n}
                  </div>
                  <div className="text-xs uppercase tracking-wider text-[#0A0A0A]/55 mt-1">
                    {k.l}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right: Visual */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-5"
          >
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
              {/* Gradient backdrop */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#E52431] via-[#6D1942] to-[#1F2C6E]" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,rgba(255,255,255,0.3),transparent_60%)]" />
              <div className="grain absolute inset-0 opacity-40" />

              {/* Logo center */}
              <div className="absolute inset-0 grid place-items-center">
                <img
                  src="/brand/logo-em-group.png"
                  alt="EM Group"
                  className="h-44 w-44 md:h-56 md:w-56 object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)]"
                />
              </div>

              {/* Bottom glass badge */}
              <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl px-5 py-4 text-white">
                <div className="flex items-center gap-3">
                  <div className="h-2.5 w-2.5 rounded-full bg-[#00FF9C] animate-pulse" />
                  <div className="text-xs uppercase tracking-wider text-white/75">
                    Basé sur 3 territoires
                  </div>
                </div>
                <div className="mt-1 font-outfit text-lg font-medium">
                  Maurice · Réunion · France
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
